<template>
  <div class="section">
    <md-field class="has-danger">
      <label>Post Title</label>
      <md-input v-model="blogTitle"></md-input>
    </md-field>
    <writer/>
  </div>
</template>

<script>
import Writer from '../components/Writer'
export default {
    components: {
        writer: Writer
    },
    props: {
        id: String
    },
    created() {
        
    }
}
</script>